import {
  BrandKit,
  InputStyleDefinition,
  Override,
} from "@redotech/redo-model/brand-kit";
import { Primitive } from "@redotech/util/type";
import { memo } from "react";
import {
  RadioGroupOption,
  RedoRadioGroup,
} from "./arbiter-components/radio/redo-radio-group";
import * as css from "./brand-kit-radio-group.module.css";
import { getInputStyles } from "./brand-kit-utils";

export interface BrandKitRadioGroupProps<T extends Primitive> {
  brandKit: BrandKit;
  options: RadioGroupOption<T>[];
  value: T;
  setValue: (value: T) => void;
  override?: Override<InputStyleDefinition>;
  disabled?: boolean;
  name?: string;
  required?: boolean;
  label?: string;
  description?: string;
}

export const BrandKitRadioGroup = memo(function BrandKitRadioGroup<
  T extends Primitive,
>({
  brandKit,
  options,
  value,
  setValue,
  override,
  disabled,
  name,
  required,
  label,
  description,
}: BrandKitRadioGroupProps<T>) {
  const style = getInputStyles(brandKit, override);

  return (
    <>
      {name && (
        <input
          name={name}
          required={required}
          type="hidden"
          value={String(value)}
        />
      )}
      <RedoRadioGroup
        className={css.brandKitRadioGroup}
        description={description}
        disabled={disabled}
        label={label}
        options={options}
        radioButtonProps={{
          dangerousStyleThatShouldOnlyBeUsedForMerchantBranding: style,
        }}
        setValue={setValue}
        size="sm"
        value={value}
      />
    </>
  );
});
